import { statusColors } from 'features/home/consts'
import theme from 'theme_'
import { mainInfoCardsMessages } from './MainInfo/messages'
import type { OverallSystemStatusType } from './types'

export const OverallSystemStatuses: OverallSystemStatusType[] = [
  {
    labelColor: theme.colors.successGreen,
    cardColor: theme.colors.successBack,
    labelText: mainInfoCardsMessages.overallStatusCardGoodLabel.defaultMessage,
  },
  {
    labelColor: statusColors[1],
    cardColor: theme.colors.lightYellow,
    labelText: 'Updating',
  },
  {
    labelColor: statusColors[2],
    cardColor: theme.colors.lightRed,
    labelText: 'Errors',
  },
  {
    labelColor: theme.colors.duneWarmGrey,
    cardColor: theme.colors.newGrey,
    labelText: 'Unavailable',
  },
]
